import withTranslation from '../../globals/components/withTranslation'
import Component from './component'
import { AdminClaimsProps } from './types'

export default withTranslation(Component) as React.ComponentClass<AdminClaimsProps>
